import { FormattedMessage } from 'react-intl';
import Button from '@ux/button';
import { useContext } from '../RenderContext';
import Card from '../Card';
import util from '../../util';
import classNames from 'classnames';
import ChatNow, { LP_CHAT_PLID } from './ChatNow';
import { FeatureFlags, useFeatureFlag } from '../../hooks/switchboard';

interface ContentProps {
  hasSupport: boolean
}

const Content = ({ hasSupport } : ContentProps) => {
  const {
    settings,
    support,
    settings: {
      envPrefix,
      privateLabelId
    }
  } = useContext();
  const isChatEnabled = useFeatureFlag(FeatureFlags.CONTACT_US_CHAT_NOW);
  const hasChatNow = !hasSupport && isChatEnabled === true && privateLabelId === LP_CHAT_PLID;

  const helpColClass = classNames({
    'col-md-4': hasChatNow,
    'col-sm-6 card-deck': !hasSupport && !hasChatNow,
    'col-sm-6 col-lg-12': hasSupport
  });
  const supportColClass = classNames({
    'col-md-4': hasChatNow,
    'col-sm-6 card-deck': !hasSupport && !hasChatNow,
    'col-sm-6 col-lg-12': hasSupport
  });

  return (
    <div className={ classNames('contactUs-sidebar container row', {
      'col-lg-3': hasSupport,
      'card-deck': !hasSupport
    }) }>
      <div className={ helpColClass }>
        <Card className="contactUs-sidebar-help">
          <h2><FormattedMessage id="contactUs.sidebar.help.title" /></h2>
          <p><FormattedMessage id="contactUs.sidebar.help.cta" /></p>
          <p>
            <Button
              design="secondary"
              href={ `https://www.${envPrefix}secureserver.net/help/?pl_id=${privateLabelId}` }
            >
              <FormattedMessage id="contactUs.sidebar.help.button" />
            </Button>
          </p>
        </Card>
      </div>

      <div className={ supportColClass }>
        { support && !!support.technical && (
          <Card className="contactUs-sidebar-support">
            <h2><FormattedMessage id="contactUs.sidebar.support.title" /></h2>
            { util.shouldRenderEnglishOnlySupportDisclaimer(settings) && (
              <p className="contactUs-englishOnly"><FormattedMessage id="contactUs.englishOnly" /></p>
            ) }
            <p>
              <span className="contactUs-sidebar-support-label">
                {!hasSupport && <FormattedMessage id="contactUs.sidebar.support.technical" />}
              </span>
              <strong className="contactUs-sidebar-support-value">
                <a href={ `tel:${util.stripNonNumerals(support.technical)}` }>{support.technical}</a>
              </strong>
            </p>
          </Card>
        ) }
      </div>
      { hasChatNow && (
        <div className="col-md-4">
          <ChatNow />
        </div>
      ) }
    </div>
  );
};

export default Content;
